import React, { PureComponent } from 'react'

class Loader extends PureComponent {
  render() {
    if (this.props.pastDelay) {
      return <div>Loading...</div>;
    } else {
      return null;
    }
  }
}

export default Loader